import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import PageLoading from '../../components/PageLoading'
import { authenticatedUserVar } from '../../providers/apollo/cache'
import NoticeRouter from './NoticeRouter'

const AccessibilityCommitment = lazy(() => import('./views/AccessibilityCommitment'))
const AffiliateHub = lazy(() => import('./views/Affiliatehub'))
const CopyrightPolicy = lazy(() => import('./views/legal/CopyrightPolicy'))
const FacebookTransfer = lazy(() => import('./views/FacebookTransfer'))
const FreeTrialSignup = lazy(() => import('./views/offer/FreeTrialSignup'))
const FreeTrialTY = lazy(() => import('./views/confirmation/FreeTrialTY'))
const GetTheApp = lazy(() => import('./views/confirmation/GetTheApp'))
const Homepage = lazy(() => import('./views/homepage'))
const Layout = lazy(() => import('./components/Layout'))
const MobileApp = lazy(() => import('./views/offer/MobileApp'))
const MoreToPhotobucket = lazy(() => import('./views/offer/MoreToPhotobucket'))
const NotFound = lazy(() => import('./views/NotFound'))
const NotFoundComponent = lazy(() => import('../../components/NotFound'))
const OneBucket = lazy(() => import('./views/offer/OneBucket'))
const OpeningUXDev = lazy(() => import('./views/opportunities/OpeningUXDev'))
const PrivacyPolicy = lazy(() => import('./views/legal/PrivacyPolicy'))
const SignUp = lazy(() => import('./views/SignUp'))
const StartUploading = lazy(() => import('./views/confirmation/StartUploading'))
const TermsOfService = lazy(() => import('./views/legal/TermsOfService'))
const ThreePlans = lazy(() => import('./views/offer/ThreePlans'))

export default function Router() {
  const user = authenticatedUserVar()

  return (
    <Layout>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="accessibility-commitment" element={<AccessibilityCommitment />} />
          <Route path="account-verified/get-the-app" element={<GetTheApp />} />
          <Route path="account-verified/start-uploading" element={<StartUploading />} />
          <Route path="affiliate-hub" element={<AffiliateHub />} />
          <Route path="m/facebook-transfer" element={<FacebookTransfer />} />
          <Route path="offer/app" element={<MobileApp />} />
          <Route path="offer/one-bucket" element={<OneBucket />} />
          <Route path="offer/more-to-photobucket" element={<MoreToPhotobucket />} />
          <Route path="offer/pick-your-plan" element={<SignUp />} />
          <Route path="offer/three-plans" element={<ThreePlans />} />
          <Route path="offer/trial" element={<FreeTrialSignup />} />
          <Route path="offer/upgrade" element={<NoticeRouter />} />
          <Route path="opportunities/ux-developer" element={<OpeningUXDev />} />
          <Route path="p/error" element={<NotFound />} />
          <Route path="legal/copyright-policy" element={<CopyrightPolicy />} />
          <Route path="legal/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="legal/terms-of-service" element={<TermsOfService />} />
          <Route path="thank-you/free-trial" element={<FreeTrialTY />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="trash" element={<Navigate to={`/u/${user?.profile?.username}/trash`} />} />
          <Route path="month-view" element={<Navigate to={`/u/${user?.profile?.username}/v/month`} />} />
          <Route path="*" element={<NotFoundComponent />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}
